export default __webpack_public_path__ + "static/media/leitner.2e8cd831.png";